import React, { useEffect, useRef, useState } from 'react';
import { ProfileContent } from './components/ProfileContent';
import { ProfileHeader } from './components/ProfileHeader';
import styles from './styles.module.css';

type Props = {
  footer: React.ReactNode;
};

const FOOTER_SELECTOR = '.modal-footer';
const MODAL_CONTAINER_SELECTOR = '.kt-modal-container';

export function BookingFormLayout({ children, footer }: React.PropsWithChildren<Props>) {
  const [maxHeight, setMaxHeight] = useState<string | number>('auto');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const modalContainer = document.querySelector<HTMLDivElement>(MODAL_CONTAINER_SELECTOR);

    const resizeObserver = new ResizeObserver((entries) => {
      const footerElem = document.querySelector(FOOTER_SELECTOR);

      window.requestAnimationFrame((): void | undefined => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        setMaxHeight(`calc(90vh - ${footerElem?.clientHeight || 0}px)`);
      });
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    if (modalContainer) {
      modalContainer.style.overflow = 'hidden';
    }

    return () => {
      resizeObserver.disconnect();

      if (modalContainer) {
        modalContainer.style.overflow = 'auto';
      }
    };
  }, []);

  return (
    <div>
      <div ref={ref} className={styles.scrollableContent} style={{ maxHeight }}>
        <ProfileHeader />
        <ProfileContent>{children}</ProfileContent>
      </div>
      {footer}
    </div>
  );
}
